'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imagesLoading = exports.productsLoading = exports.getOneImage = exports.getOneProduct = exports.getImagesList = exports.imagesState = exports.oneImageState = exports.oneProductState = exports.purchasedProductsByAccountState = exports.productsState = undefined;

var _immutable = require('immutable');

var _reselect = require('reselect');

var productsState = exports.productsState = function productsState(state, feis_id) {
  return state.getIn(['feiseanna', 'products', feis_id], (0, _immutable.List)());
};

var purchasedProductsByAccountState = exports.purchasedProductsByAccountState = function purchasedProductsByAccountState(state, feis_id, acct_id) {
  return state.getIn(['accounts', acct_id, 'feiseanna', feis_id, 'products'], (0, _immutable.List)());
};

var oneProductState = exports.oneProductState = function oneProductState(state, product_id) {
  return state.getIn(['products', 'one', product_id], (0, _immutable.Map)());
};

var oneImageState = exports.oneImageState = function oneImageState(state, image_id) {
  return state.getIn(['images', 'one', image_id], (0, _immutable.Map)());
};

var imagesState = exports.imagesState = function imagesState(state, product_id) {
  return state.getIn(['products', 'images', product_id], (0, _immutable.List)());
};

var getImagesList = exports.getImagesList = (0, _reselect.createSelector)(imagesState, function (imagesState) {
  return imagesState || (0, _immutable.List)();
});

var getOneProduct = exports.getOneProduct = (0, _reselect.createSelector)(oneProductState, function (product) {
  return product;
});

var getOneImage = exports.getOneImage = (0, _reselect.createSelector)(oneImageState, function (image) {
  return image || (0, _immutable.Map)();
});

var productsLoading = exports.productsLoading = function productsLoading(state) {
  return state.getIn(['products', 'one', 'loading']);
};

var imagesLoading = exports.imagesLoading = function imagesLoading(state) {
  return state.getIn(['images', 'one', 'loading']);
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/selectors/products/index.js
// module id = 111
// module chunks = 0